import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

@Injectable()
export class CustomerAuthActions {
    static CUSTOMER_LOAD_DATA = '[Auth-Customer] Load customer data';
    static COOKIE_NOTIFICATION_ACCEPT = '[Auth-Customer] Accept Cookies';

    loadCustomerData(customerData: any): RidangoReduxAction {
        return {
            type: CustomerAuthActions.CUSTOMER_LOAD_DATA,
            payload: customerData
        };
    }

    acceptCookies(value: boolean): RidangoReduxAction {
        return {
            type: CustomerAuthActions.COOKIE_NOTIFICATION_ACCEPT,
            payload: value
        };
    }
}
